import { FC } from 'react';
import { Control, FieldValues } from 'react-hook-form';
import { Box } from '@altermaind/web/ui';
import { Form } from '@/_shared/components/Form';
import { postSurveysCampaignByIdNextCall } from '@/surveys/state/api/postSurveysCampaignByIdNextCall';

type Props = {
  currentStep: ReturnType<(typeof postSurveysCampaignByIdNextCall)['hook']>['activeStep'];
  control: Control<FieldValues>;
};
export const RangeChoiceAnswer: FC<Props> = ({ currentStep, control }) => {
  return (
    <Box>
      <Form.FormRange
        minLabel={currentStep.nextQuestion?.differentialScale?.leftLabel || ''}
        maxLabel={currentStep.nextQuestion?.differentialScale?.rightLabel || ''}
        values={currentStep.nextQuestion?.differentialScale?.scaleValues || [0, 100]}
        // @ts-ignore
        control={control}
        name={currentStep.nextQuestion?.id || 'rangeChoiceAnswer'}
        defaultValue={currentStep.nextQuestion?.differentialScale?.scaleValues?.[0] || 0}
      />
    </Box>
  );
};
